import { render, staticRenderFns } from "./ReviewsRepliesList.vue?vue&type=template&id=48f02b67&scoped=true&"
import script from "./ReviewsRepliesList.vue?vue&type=script&lang=js&"
export * from "./ReviewsRepliesList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsRepliesList.vue?vue&type=style&index=0&id=48f02b67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f02b67",
  null
  
)

export default component.exports